var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "button",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.dialogList.show()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessStockSynchronizationAdd.titleBtn")
                        )
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.tryCancel } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("BusinessStockSynchronizationAdd.title")) + " ")]
      ),
      _c(
        "el-form",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockSynchronizationAdd.code"),
                      },
                    },
                    [
                      _c("span", { staticClass: "tips" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessStockSynchronizationAdd.codeText")
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockSynchronizationAdd.logicBinCode"
                        ),
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.info.code) + " "),
                      !_vm.info.code
                        ? _c("span", { staticClass: "tips" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessStockSynchronizationAdd.codeSelect"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockSynchronizationAdd.name"),
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.info.name) + " "),
                      !_vm.info.name
                        ? _c("span", { staticClass: "tips" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessStockSynchronizationAdd.nameText"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remarkText") } },
                    [
                      _c("BjTextarea", {
                        attrs: { placeholder: _vm.$t("table.remarkText") },
                        model: {
                          value: _vm.info.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.info, "remark", $$v)
                          },
                          expression: "info.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "button",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.dialogListGoodsShow()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BusinessStockSynchronizationAdd.selectProduct"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.selectedRow.length == 0,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onDelSelected()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessStockSynchronizationAdd.delProduct")
                        )
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            _vm._s(_vm.$t("BusinessStockSynchronizationAdd.commodityDetails")) +
              " "
          ),
        ]
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
            "max-height": "600px",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              align: "center",
              width: "60",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "categoryName",
              align: "center",
              label: _vm.$t("goodsPage.categoryName"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              align: "center",
              label: _vm.$t("goodsPage.skuCode"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuName",
              align: "center",
              label: _vm.$t("goodsPage.skuName"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "num",
              align: "center",
              label: _vm.$t("BusinessStockSynchronizationAdd.num"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input-number", {
                      staticClass: "full-width",
                      attrs: { precision: 0, controls: false },
                      model: {
                        value: row.num,
                        callback: function ($$v) {
                          _vm.$set(row, "num", $$v)
                        },
                        expression: "row.num",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: { config: _vm.$BjDialogListConfig.stockWarehouseLogic() },
        on: { confirm: _vm.onConfirmDialogList },
      }),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: { config: _vm.$BjDialogListConfig.skuDefault(), multiple: "" },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }